/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-2",
    "aws_cognito_identity_pool_id": "ap-southeast-2:93d01a1d-2f0d-42d1-bb54-45f774726989",
    "aws_cognito_region": "ap-southeast-2",
    "aws_user_pools_id": "ap-southeast-2_BG2OL2WRy",
    "aws_user_pools_web_client_id": "2ffn2b78ftpr804v7e0gjth9qs",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "email"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "email","phone_number","preferred_username"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SOFTWARE_TOKEN_MFA"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 12,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
